<template>
    <div style="padding:12px">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button type="primary" size="medium" @click="jumpToPage('activatingCodeList', {schoolId, id: detail.id})">激活码
            </el-button>
            <el-button type="primary" size="medium" @click="openAutoActivate()" :disabled="openAutoActiveFlag">{{openAutoActiveFlag ? '已开启自动激活' : '开启自动激活'}}
            </el-button>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <div class="main-panel">
                <el-form label-width="140px" class="form--display">
                    <el-form-item label="学校名称">
                        {{schoolName}}
                    </el-form-item>
                    <el-form-item label="享受优惠政策">
                        {{detail.supportPolicy}}
                    </el-form-item>
                    <el-form-item label="激活情况">
                        已激活账号数{{detail.activatedCount}}个/需要激活账号数{{detail.needActivateCount}}个
                    </el-form-item>
                    <el-form-item label="已购买激活码">
                        {{detail.buyBaseCount}}个
                    </el-form-item>
                    <el-form-item label="最近到期情况">
                        {{detail.recentExpireCount}}个激活码将在{{detail.recentExpireTime}}到期
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import baseMixin from '@/mixins/baseMixin';
    import mixin from "@/mixins/windowResize";
    import {
        activeInfo,
        deleteOrder,
        setAutoActive
    } from '@/api/schoolManage';
    import {isShowByPermission} from '@/utils/utils';

    export default {
        name: 'schoolDetail',
        components: {ImagePreviewer},
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : ''
            }
        },
        mixins: [baseMixin, mixin],

        data() {
            return {
                schoolId: this.$route.query.schoolId,
                schoolName: this.$route.query.schoolName,
                corpId: this.$route.query.corpId,
                detail: {},
                openAutoActiveFlag: false
            }
        },
        created() {
            activeInfo({
                schoolId: this.schoolId
            })
                .then(data => {
                    if (data) {
                        this.detail = data;
                        this.openAutoActiveFlag = data.openAutoActiveFlag;
                    }
                });
        },
        methods: {
            isShowByPermission,
            openAutoActivate() {
                setAutoActive({
                    schoolId: this.schoolId
                })
                    .then(() => {
                        this.$message.success('设置成功');
                        window.setTimeout(() => {
                            this.$router.back();
                        }, 500);
                    });
            },
            deleteHandler() {
                this.$confirm("确认要删除吗？", "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    deleteOrder({
                        orderCode: this.detail.orderId
                    })
                        .then(() => {
                            this.$message.success('删除成功');
                            window.setTimeout(() => {
                                this.$router.back();
                            }, 500);
                        });
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    .main-panel {
        width: 810px;
        margin: 10px auto;
    }

    .right-panel {
        float: left;
    }

    .title {
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;

        &:not(:first-of-type) {
            margin-top: 40px;
        }
    }

    .top {
        border-bottom: 1px solid #e7eaec;
        padding-bottom: 10px;
    }

    .body {
        overflow: auto;
        padding-top: 10px;
    }

    .left-panel-btn-item {
        margin: 10px 0;
    }

    .detail-item {
        margin: 20px 0;

        & > * {
            display: inline-block;
        }
    }

    .detail-item__title {
        width: 200px;
    }

    .detail-item__value {
        padding-left: 16px;
        width: 500px;
        color: #909399;

    }

    .logo-list {
        margin-top: 20px;
        background: #ccc;
        padding: 10px;

        & > * {
            @include middleIB;
        }

        .logo-item {
            text-align: center;
            margin-right: 10px;
            font-size: 14px;

            img {
                height: 100px;
            }
        }
    }

    @media screen and (max-width: 1600px) {
        .left-panel {
            margin-left: 100px;
        }
    }

    @media screen and (max-width: 1450px) {
        .left-panel {
            margin-left: 40px;
            width: 200px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolIntGrant.vue